var React = require('react');

function TipsUpdates (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.25 21.5H10.25C10.25 22.6 9.35 23.5 8.25 23.5C7.15 23.5 6.25 22.6 6.25 21.5ZM4.25 20.5H12.25V18.5H4.25V20.5ZM15.75 11C15.75 14.82 13.09 16.86 11.98 17.5H4.52C3.41 16.86 0.75 14.82 0.75 11C0.75 6.86 4.11 3.5 8.25 3.5C12.39 3.5 15.75 6.86 15.75 11ZM13.75 11C13.75 7.97 11.28 5.5 8.25 5.5C5.22 5.5 2.75 7.97 2.75 11C2.75 13.47 4.24 14.89 5.1 15.5H11.4C12.26 14.89 13.75 13.47 13.75 11ZM20.62 8.87L19.25 9.5L20.62 10.13L21.25 11.5L21.88 10.13L23.25 9.5L21.88 8.87L21.25 7.5L20.62 8.87ZM18.25 7.5L19.19 5.44L21.25 4.5L19.19 3.56L18.25 1.5L17.31 3.56L15.25 4.5L17.31 5.44L18.25 7.5Z","fill":"#F1F9EC"}));
}

TipsUpdates.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = TipsUpdates;

TipsUpdates.default = TipsUpdates;
